import { render, staticRenderFns } from "./duty.vue?vue&type=template&id=5a1fdd98&"
import script from "./duty.vue?vue&type=script&lang=js&"
export * from "./duty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports